<script lang="ts">
    import { VpCheckIcon } from '@decathlon-experience/icons/svelte';

    export let checked: boolean = false;
    export let onChange: (checked: boolean) => void = () => {};
</script>

<span class="relative inline-flex h-xl w-3xl shrink-0 cursor-pointer">
    <input
        type="checkbox"
        class="peer sr-only"
        {checked}
        on:change={(event) => onChange(event.currentTarget.checked)}
        {...$$restProps}
    />
    <span
        class="h-full w-full rounded-full border border-solid border-border-neutral bg-container-quiet transition-colors
            after:absolute after:left-2xs after:top-1/2 after:size-m after:-translate-y-1/2 after:rounded-full after:bg-content-quiet after:transition-transform after:content-['']
            peer-checked:border-0 peer-checked:bg-blue-brand peer-checked:after:translate-x-m peer-checked:after:bg-white"
    >
    </span>
    <VpCheckIcon
        size={16}
        class="absolute right-2xs top-1/2 hidden -translate-y-1/2 text-content-brand peer-checked:block"
    />
</span>
